import {
  Flex,
  Table,
  Button,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { EditIcon, AddIcon, DeleteIcon, ViewIcon } from '@chakra-ui/icons';
import moment from 'moment';
import AddModal from './addModal';
import EditModal from './editModal';
import PopDelete from './deletePopover';
import ConfigModal from './configModal';
import BullionDeskAPI from '../../../../api/bulliondesk';
import OperationLocationAPI from '../../../../api/operationlocation';
import MultiSelect from 'components/autocomplete/autocomplete';
import { MetalTypesOptions } from 'config/constant';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';

const generateLocationObjects = (list) => {
  console.log('List', list);
  const filterObjects = Array.from(list).map((item) => {
    return {
      value: item.id,
      label: `${item.name}`,
    };
  });

  return filterObjects;
};

export default function TableData(props) {
  const { secondary } = props;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [operationList, setOperationList] = useState([]);
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [buy, setBuy] = useState();
  const [sell, setSell] = useState();
  const [exchange, setExchange] = useState();
  const [selectedType, setselectedType] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  // const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const { getPermissionsForModule } = usePermissions();
  const [bullionDeskPermissions, setBullionDeskPermissions] = useState(null);
  const [fetchBulliondeskListError, setFetchBulliondeskListError] =
    useState(false);

  const selectedTypeValue = Array.isArray(selectedType)
    ? selectedType?.map((option) => option.value).join(',')
    : selectedType.value;

  const selectedLocationValue = Array.isArray(selectedLocation)
    ? selectedLocation?.map((option) => option.value).join(',')
    : selectedLocation.value;

  const fetchList = async () => {
    try {
      setLoading(true);
      let response = await BullionDeskAPI.List({
        currentPage,
        itemsPerPage,
        // sort: 'name:asc',
        searchTerm,
        selectedTypeValue,
        selectedLocationValue,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list) {
        setFetchBulliondeskListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchBulliondeskListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchBulliondeskListError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    const bullionDeskPermissions = getPermissionsForModule([
      Modules.BullionDesk,
    ]);
    setBullionDeskPermissions(bullionDeskPermissions);
  }, [
    getPermissionsForModule,
    currentPage,
    searchTerm,
    selectedType,
    selectedLocation,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedType, selectedLocation]);

  console.log('Bullion desk permissions', bullionDeskPermissions);

  const FetchOperationLocationList = async () => {
    try {
      let response = await OperationLocationAPI.List({
        currentPage: 1,
        itemsPerPage: 100,
        sort: 'name:asc',
        booleanFilter: true,
      });
      response = response.data;
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setOperationList(response?.data?.list);
      } else {
        setOperationList([]);
      }
    } catch (err) {
      console.log(err);
      setOperationList([]);
    }
  };
  useEffect(() => {
    if (bullionDeskPermissions?.read) {
      fetchList();
      FetchOperationLocationList();
    }
  }, [bullionDeskPermissions]);

  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  const handleDelete = async (id) => {
    console.log('delete pop called');
    try {
      const response = await BullionDeskAPI.Delete(id);
      if (response.data.status_code === 200) {
        toast({
          title: 'Successfully Deleted',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        fetchList();
      } else {
        let error = response.data.message;
        toast({
          title: error,
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
      fetchList();
    } catch (err) {
      console.log(err);
    }
  };
  const handleUpdate = async (onClose, id) => {
    try {
      let request = {
        id: id,
        name: name,
        display_order: Number(displayOrder),
      };
      const response = await BullionDeskAPI.Update({
        id,
        sell,
        buy,
        exchange,
      });
      if (response.data.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully Updated',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        fetchList();
      } else if (response.data.status_code != 200) {
        toast({
          title: response?.data?.message,
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  if (!bullionDeskPermissions?.read) {
    return <NoPermissionsMessage module={Modules.BullionDesk} />;
  }

  return fetchBulliondeskListError ? (
    <PageError />
  ) : (
    <Flex height='100%' mt='8rem' direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={5}
        mb='20px'
        width='100%'
        gap={10}
      >
        <Flex flex={1}>
          <MultiSelect
            options={MetalTypesOptions}
            isMulti={true}
            placeholder='Select Type'
            value={selectedType}
            onChange={setselectedType}
          />
        </Flex>
        <Flex flex={1}>
          <MultiSelect
            options={generateLocationObjects(operationList)}
            isMulti={true}
            placeholder='Select Location'
            value={selectedLocation}
            onChange={setSelectedLocation}
          />
        </Flex>
        <Flex ml='auto'>
          <Tooltip
            label={
              !bullionDeskPermissions.create
                ? 'You do not have permission to configure'
                : undefined
            }
            placement='top'
            shouldWrapChildren
          >
            <Flex justify='center' mr={3}>
              <ConfigModal
                disabled={!bullionDeskPermissions.create}
              />
            </Flex>
          </Tooltip>
          <Tooltip
            label={
              !bullionDeskPermissions.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren
          >
            <Flex justify='center'>
              <Chakralink
                top='14px'
                right='14px'
                mt={{
                  base: '0px',
                  md: '10px',
                  lg: '0px',
                  xl: '10px',
                  '2xl': '0px',
                }}
              >
                <Link
                  to={{
                    pathname: `/admin/addnewbulliondesk`,
                  }}
                >
                  <Button
                    variant='lightBrand'
                    fontSize='sm'
                    fontWeight='500'
                    borderRadius='10px'
                    boxShadow='lg'
                    px='15px'
                    py='5px'
                    disabled={!bullionDeskPermissions.create}
                  >
                    <AddIcon />
                  </Button>
                </Link>
              </Chakralink>
            </Flex>
          </Tooltip>
        </Flex>
      </Flex>

      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}
      >
        <Table variant='striped' color='gray.500' mb='24px'>
          <Thead>
            <Tr>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Sr.no
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Type
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Location
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Customer Sell Price
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Customer Buy Price
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Start
                </Flex>
              </Th>
              <Th pe='10px' borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  End
                </Flex>
              </Th>
              <Th
                // bgColor='red'
                borderColor={borderColor}
              >
                <Flex
                  ps={4}
                  // justify='center'
                  // bgColor='yellow'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'
                >
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {
                          MetalTypesOptions.find(
                            (option) => option.value === obj?.type
                          )?.label
                        }
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.operation_location}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.sell}/{obj.unit}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {obj.buy}/{obj.unit}
                      </Text>
                    </Flex>
                  </Td>

                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                      >
                        {moment(obj.start).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Text
                      me='10px'
                      color={textColor}
                      fontSize='sm'
                      fontWeight='700'
                    >
                      {moment(obj.expiry).format('DD MMM YY, HH:mm')}
                    </Text>
                  </Td>
                  <Td>
                    <Flex
                      // justify='center'
                      // bgColor='yellow'
                      gap={2} // Adjust the gap between elements (4 is just an example)
                    >
                      <Tooltip
                        label={
                          !bullionDeskPermissions.update
                            ? 'You do not have permission to edit'
                            : undefined
                        }
                        placement='top'
                        shouldWrapChildren
                      >
                        <Flex justify='center'>
                          {/* <EditModal
                          Icon={<EditIcon />}
                          head={'Update Customer Admin User'}
                          func={FetchCustomerSavingPlans}
                          currentUser={obj}
                        /> */}
                          <Chakralink>
                            <Link
                              to={{
                                pathname: `/admin/bullion-desk/${obj.id}`,
                              }}
                            >
                              <Button>
                                <ViewIcon />
                              </Button>
                            </Link>
                          </Chakralink>
                        </Flex>
                      </Tooltip>

                      {obj.is_active === true && (
                        <Tooltip
                          label={
                            !bullionDeskPermissions.update
                              ? 'You do not have permission to Delete'
                              : undefined
                          }
                          placement='top'
                          shouldWrapChildren
                        >
                          <PopDelete
                            Icon={<DeleteIcon />}
                            disabled={!bullionDeskPermissions.update}
                            handleDelete={handleDelete}
                            id={obj.id}
                          />
                        </Tooltip>
                      )}
                      {obj.is_active === false && (
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'
                          >
                            Deleted
                          </Text>
                        </Flex>
                      )}
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
